import React from 'react'
import { Button } from '@material-ui/core'
import { Link } from 'react-router-dom'

const NotFound = () => {
    return (
        <div style={{backgroundColor:"white"}} className="flex justify-center items-center h-full-screen w-full">
            <div className="flex-column justify-center items-center max-w-320">
                {/* <img
                    className="mb-8 w-full"
                    src={warn}
                    alt=""
                /> */}
                <center><div className='pb-4'><h2>Oops!!Something went wrong</h2></div></center>
                <Link to="/Dashboard">
                    <Button
                        className="capitalize"
                        variant="contained"
                        color="primary"
                    >
                        Back to Dashboard
                    </Button>
                </Link>
            </div>
        </div>
    )
}

export default NotFound
